export default __webpack_public_path__ + "static/media/UnderRepaired.6658b3b7.svg";